<template>
  <div>
    <v-layout class="pt-4">
      <v-flex sm3 class="pl-4 borderRight"># Project Title</v-flex>
      <v-flex sm9>
        <v-layout class="text-sm-center">
          <template
            v-if="
              statusId == 8 ||
              statusId == 10 ||
              statusId == 11 ||
              statusId == 13
            "
          >
            <v-flex sm1 class="borderRight">Pending</v-flex>
            <v-flex sm2 class="borderRight">Modifications</v-flex>
            <v-flex sm2 class="borderRight">Rejected</v-flex>
            <v-flex sm2 class="borderRight">Responses</v-flex>
            <v-flex sm2 class="borderRight">Budget</v-flex>
          </template>
          <v-flex v-else sm9 class="borderRight"></v-flex>
          <v-flex sm3>Actions</v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex sm12>
        <v-layout>
          <v-flex sm12>
            <v-card v-if="indexDataLoading || loading" class="pa-3 my-4 noData">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-card>

            <div v-else-if="indexData.total">
              <v-card
                class="py-4 my-3"
                v-for="data in indexData.data"
                :key="`data${data.id}`"
              >
                <v-layout class="project-row">
                  <v-flex sm3>
                    <v-layout>
                      <v-flex sm3 text-xs-center>
                        <span class="serial mx-2">{{ data.id }}</span>
                      </v-flex>
                      <v-flex sm9 class="left-menu my-2">
                        <div
                          v-for="value in Object.keys(data.left_menu)"
                          :key="value"
                        >
                          <h2
                            v-if="value == 'project title'"
                            class="title"
                            @click="checkItem(data.id)"
                            style="cursor: pointer"
                          >
                            {{ data.left_menu[value] }}
                          </h2>
                          <p class="capitalize" v-else>
                            <span
                              style="
                                font-size: 14px;
                                font-weight: 500;
                                margin-right: 5px;
                              "
                            >
                              {{ value.split("_").join(" ") }}:
                            </span>
                            <span>{{ data.left_menu[value] }}</span>
                          </p>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex sm9>
                    <v-layout class="text-sm-center" align-center fill-height>
                      <template
                        v-if="
                          statusId == 8 ||
                          statusId == 10 ||
                          statusId == 11 ||
                          statusId == 13
                        "
                      >
                        <v-flex sm1>{{ data.total_pending_res }}</v-flex>
                        <v-flex sm2>{{ data.total_modified_res }}</v-flex>
                        <v-flex sm2>{{ data.total_rejected_res }}</v-flex>
                        <v-flex sm2>
                          <v-tooltip top color="error">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ data.total_accepted_res }}
                              </span>
                            </template>
                            <span>Accepted</span>
                          </v-tooltip>
                          |
                          <v-tooltip top color="error">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ data.number_of_response }}
                              </span>
                            </template>
                            <span>Required</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex sm2>
                          <v-tooltip top color="error">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ data.budget_remains / 10 }}
                              </span>
                            </template>
                            <span>Remaining</span>
                          </v-tooltip>
                          |
                          <v-tooltip top color="error">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ data.total_budget_amount }}
                              </span>
                            </template>
                            <span>Total</span>
                          </v-tooltip>
                        </v-flex>
                      </template>
                      <v-flex v-else sm9 />
                      <v-flex sm3>
                        <div v-for="action in data.actions" :key="action">
                          <div class="actions">
                            <template v-if="action === 'Delete'"></template>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Preview'"
                              @click="checkItem(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="
                                (action === 'Respondent Analytics' ||
                                  action === 'Project Summary') &&
                                data.agent_option != '3'
                              "
                              @click="projectSum(data.id)"
                            >
                              Project Summary
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Edit'"
                              @click="editItem(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Pause'"
                              @click="changeProjectStatusToPause(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Resume'"
                              @click="changeProjectStatusToLive(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Schedule'"
                              @click="goToLive(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Live'"
                              @click="goToLive(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Responses'"
                              @click="getResponse(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Change Date'"
                              @click="expandDate"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Complete'"
                              @click="updateProjectToCompleteStatus(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Add Budget'"
                              @click="openAddBudgetDialog(data)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn
                              class="w-165"
                              small
                              v-else-if="action === 'Response Analytics'"
                              @click="responseAnalytics(data.id)"
                            >
                              {{ action }}
                            </v-btn>
                            <v-btn class="w-165" small v-else>
                              {{ action }}
                            </v-btn>
                          </div>
                        </div>
                      </v-flex>
                      <v-dialog v-model="dialog" width="400">
                        <v-card>
                          <v-card-title class="title blue accent-3">
                            Timer Dialog
                          </v-card-title>
                          <v-card-text>
                            <div>
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="190px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="updateData.end_date"
                                    :rules="endTime"
                                    label="Expand Project Ending Time *"
                                    v-bind="attrs"
                                    prepend-icon="event"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  ref="picker"
                                  v-model="updateData.end_date"
                                  :min="new Date().toISOString().substr(0, 10)"
                                  @change="save"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-btn color="success" flat @click="close">
                              close
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="success"
                              flat
                              @click="updateProjectEndingTime"
                            >
                              save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
            <v-card v-else class="pa-3 my-4 noData">No data found</v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addBudgetDialog" width="400" v-if="selectedProject">
      <v-card>
        <v-card-title>
          <h2>Add Budget</h2>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="noOfResponses"
              :rules="[(v) => !!v || 'No. of Responses is required']"
              label="No. of Responses*"
              required
              type="number"
            ></v-text-field>
            <v-text-field
              label="Per Survey Cost"
              disabled
              :value="
                selectedProject.total_budget_amount /
                selectedProject.number_of_response
              "
            ></v-text-field>
            <v-text-field
              label="Increased Budget"
              disabled
              :value="
                noOfResponses
                  ? (noOfResponses * selectedProject.total_budget_amount) /
                    selectedProject.number_of_response
                  : 0
              "
            ></v-text-field>
            <v-btn
              color="primary"
              :disabled="!noOfResponses"
              :loading="addBudgetLoading"
              class="mx-0"
              @click="addBudget"
            >
              Submit
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addBudgetErrorDialog"
      width="400"
      v-if="selectedProject"
      persistent
    >
      <v-card class="pa-2">
        <v-card-title>
          <h2 class="red--text">
            You don't have enough balance in your wallet. Please Top UP.
          </h2>
        </v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-btn class="primary" @click="$router.push('/client-payment-page')">
            Top Up
          </v-btn>
          <v-spacer />
          <v-btn class="error" @click="addBudgetErrorDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout
      class="d-flex flex-row"
      v-if="indexData.total && !indexDataLoading && !loading"
    >
      <v-flex sm9>
        <v-pagination
          v-model="page"
          :length="indexData.last_page"
          :total-visible="5"
          color="#f66"
          class="mt-3"
          @input="initialize"
        ></v-pagination>
      </v-flex>
      <v-flex sm3>
        <v-select
          :items="[5, 10, 20, 50, 100]"
          label="Projects per page"
          v-model="per_page"
          @change="changePerPage"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" :color="color" bottom right>
      {{ msg }}
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "../../router";
import { ROOT_URL } from "@/api/connectingUrls";
import axios from "axios";
import api from "../../api/datadash";
export default {
  props: ["statusId", "searchText", "startDate", "endDate"],
  data() {
    return {
      page: 1,
      per_page: 5,
      loading: false,
      dialog: false,
      updateData: {
        project_id: null,
        end_date: null,
      },
      endTime: [(v) => !!v || "Enter project ending time"],
      menu: false,
      addBudgetDialog: false,
      addBudgetErrorDialog: false,
      noOfResponses: null,
      selectedProject: null,
      addBudgetLoading: false,
      snackbar: false,
      color: "success",
      msg: "",
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
      "indexDataLoading",
    ]),
  },
  mounted() {
    this.initialize();
  },
  watch: {
    searchText() {
      this.initialize();
    },
    startDate() {
      this.initialize();
    },
    endDate() {
      this.initialize();
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
    },
    // dialog(val) {
    //   val || this.close();
    // },
  },
  methods: {
    initialize() {
      this.$store.dispatch("getPaginatedIndexData", [
        "project",
        this.searchText,
        this.page,
        this.per_page,
        this.statusId,
        this.startDate,
        this.endDate,
      ]);
    },
    changePerPage() {
      this.page = 1;
      this.initialize();
    },
    checkItem(projectId) {
      this.loading = true;
      // this.$store.dispatch("getProjectDetails", [projectId, "client-view"]);
      this.$router.push(`/project/${projectId}/preview`);
    },
    projectSum(projectId) {
      this.loading = true;
      // this.$store.dispatch("getProjectDetails", [projectId, "client-view"]);
      this.$router.push(`/project/${projectId}/summary`);
    },
    editItem(projectId) {
      this.loading = true;
      localStorage.setItem("project_id_edit", JSON.stringify(projectId));
      this.$store.dispatch("indexDataAndRout", [
        "project-info",
        projectId,
        "/create-project-edit",
      ]);
    },
    changeProjectStatusToPause(projectId) {
      var popUpMsg = confirm("Are you sure you want to pause this project?");
      if (popUpMsg) {
        this.$store.dispatch("pauseOrResumeProjectStatus", [
          projectId,
          "project-pause-resume",
        ]);
      }
    },
    changeProjectStatusToLive(projectId) {
      var popUpMsg = confirm("Are you sure you want to live this project?");
      if (popUpMsg) {
        this.$store.dispatch("pauseOrResumeProjectStatus", [
          projectId,
          "project-pause-resume",
        ]);
      }
    },
    getResponse(projectId) {
      // this.loading = true;
      // this.$store.dispatch("getProjectResponse", [projectId, "task"]);
      this.$router.push(`/project/${projectId}/responses`);
    },
    goToLive(projectId) {
      localStorage.setItem("project_details_by_id", projectId);
      localStorage.setItem("projectId", projectId);
      router.push("success-pay");
    },
    expandDate() {
      // console.log(this.indexData);
      this.updateData.end_date = this.indexData.data[0].end_date;
      this.updateData.project_id = this.indexData.data[0].id;
      this.dialog = true;
    },
    save(date) {
      if (typeof this.$refs.menu.save === "function") {
        this.$refs.menu.save(date);
      }
      // this.$refs.menu.save(date);
      this.menu = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async updateProjectEndingTime() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          return axios
            .post(`${ROOT_URL}/${"update-ending-time"}`, this.updateData, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // console.log(response);
              if (response.data.statusCode == 200) {
                this.initialize();
                this.close();
              }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },
    async updateProjectToCompleteStatus(projectId) {
      var popUpMsg = confirm(
        "Are you sure to change project status to complete!"
      );
      if (popUpMsg) {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            return axios
              .get(`${ROOT_URL}/${"update-status"}/${projectId}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                // console.log(response);
                if (response.data.statusCode == 200) {
                  this.initialize();
                }
              });
          }
        } catch (error) {
          // console.log(error);
        }
      }
    },
    openAddBudgetDialog(project) {
      this.selectedProject = project;
      this.addBudgetDialog = true;
    },
    async addBudget() {
      this.addBudgetLoading = true;
      try {
        const { data } = await api.storeData(
          window.localStorage.getItem("datadash_token"),
          "add-budget",
          {
            project_id: this.selectedProject.id,
            number_of_response: this.noOfResponses,
          }
        );
        if (data.error) {
          if (data.statusCode == 403) {
            this.addBudgetErrorDialog = true;
          }
        } else {
          this.msg = "Updated successfully";
          this.color = "success";
          this.snackbar = true;
          this.initialize();
        }
        this.addBudgetLoading = false;
      } catch (e) {
        //
      }
      this.addBudgetDialog = false;
    },
    responseAnalytics(projectId) {
      this.$router.push(`/project/${projectId}/response-analytics`);
    },
  },
};
</script>
<style scoped>
.borderRight {
  border-right: 1px solid #aaa;
}
.serial {
  font-size: 10px;
  color: #fff;
  background: #666;
  border-radius: 50%;
  width: 40px;
  display: block;
  text-align: center;
  padding: 20% 0;
}
.left-menu {
  font-size: 13px;
}
.left-menu p {
  font-weight: 500;
}
.left-menu p span {
  font-weight: 400;
  font-size: 14px;
}
.capitalize {
  text-transform: capitalize;
}
.noData {
  text-align: center;
  font-weight: 500;
  font-size: 18px;
}
.w-165 {
  width: 165px;
  height: 28px;
  margin: 0 0 12px;
}
.actions {
  display: none;
}
.project-row:hover .actions {
  display: block;
}
.title {
  color: #f66;
  margin-bottom: 20px;
  font-weight: 600;
}
</style>
